export const getProductPath = (product: { id: number; slug: string; code: string }) => {
  return `/product/${product.id}/${product.slug}/${product.code}`;
};
